import { gql } from '@apollo/client';

export const SEND_SIGN_FILE_REMINDER = gql`
  mutation SIGN_SERVICE_sendSignFileReminder($documentId: String!) {
    sendSignFileReminder(documentId: $documentId) {
      documentId
    }
  }
`;
